import css from 'styled-jsx/css';
import { MQ_MEDIUM_ONLY } from 'constants/mq';
import { sharedPalette } from 'styles/colors/constants';

export default css`
  .Figure__image-toolbar {
    border: 1px solid #d6d1d1;
    display: flex;
    justify-content: end;
    width: 100%;
  }

  .Figure__image-save-image {
    font-size: 11px;
    display: flex;
    align-items: center;
  }

  .Figure__image-save-image span {
    color: #705e5d;
    font-weight: bold;
    margin-left: 0.15rem;
  }

  .Figure__image-toolbar :global(.PrismEntryButton--button) {
    margin-left: auto;
    align-items: center;
  }

  .Figure__image-toolbar :global(.PinItButton) {
    padding: 0 0.5rem;
    position: inherit;
  }

  .Figure__image-toolbar :global(.icon--heart) {
    position: relative;
    right: 0.2rem;
    width: 1rem;
    height: 1rem;
  }

  .Figure__image-save-image.saved :global(.icon--heart) {
    color: red;
  }

  .Figure__image-save-image,
  .Figure__image-toolbar :global(.PinItButton) {
    border: none;
    border-right: 1px solid #e4e4e4;
  }

  .Figure__image-save-image:hover,
  .Figure__image-toolbar :global(.PinItButton:hover) {
    background-color: ${sharedPalette.watermelon};
    color: white;
  }

  .Figure__image-save-image:hover :global(.icon--heart) {
    stroke: white;
  }

  .Figure__image-save-image:hover span,
  .Figure__image-toolbar :global(.PinItButton:hover span),
  .Figure__image-toolbar :global(.PinItButton:hover svg) {
    color: white;
    fill: white !important;
  }

  /* Note just throw this here temporarily. This should prob be moxed to own component */
  .Modal__window :global(img) {
    position: relative;
  }

  @media ${MQ_MEDIUM_ONLY} {
    .Figure__image-save-image span {
      display: none;
    }
  }
`;
